import React, { useEffect, useState, useMemo, useCallback } from 'react';
import styles from './SearchableStartupDropdown.module.css';
import apiClient from '../api/apiClient';

const StartupSearchInput = ({
  selectedStartup,
  setSelectedStartup,
  handleSelect = () => {}, // Optional with default no-op
}) => {
  const client = apiClient('survey');
  const [inputFocused, setInputFocused] = useState(false);
  const [startups, setStartups] = useState([]);

  const fetchStartups = useCallback(async () => {
    try {
      const response = await client.get('/surveys/list/startups');
      setStartups(response.data);
    } catch (error) {
      console.error('Failed to fetch startups:', error);
      alert('Failed to load startups.');
    }
  }, [client]);

  useEffect(() => {
    fetchStartups();
  }, [fetchStartups]);

  const filteredStartups = useMemo(() => {
    const filtered = selectedStartup
      ? startups.filter((s) =>
          s.toLowerCase().includes(selectedStartup.toLowerCase())
        )
      : startups;
    return [...filtered].sort((a, b) => a.localeCompare(b));
  }, [startups, selectedStartup]);

  return (
    <div className={styles.inputWrapper}>
      <input
        className={styles.input}
        type="text"
        placeholder="Search startup..."
        value={selectedStartup}
        onChange={(e) => setSelectedStartup(e.target.value)}
        onFocus={() => setInputFocused(true)}
        onBlur={() => setTimeout(() => setInputFocused(false), 200)}
      />
      {inputFocused && filteredStartups.length > 0 && (
        <div className={styles.suggestionBox}>
          {filteredStartups.map((startup) => (
            <div
              key={startup}
              className={styles.suggestionItem}
              onMouseDown={() => {
                setSelectedStartup(startup);
                setInputFocused(false);
                handleSelect(startup);
              }}
            >
              {startup}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default StartupSearchInput;
